module.exports = __webpack_public_path__ + "img/task_check_mark.85a00655.svg";